var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FileType } from '@office-start/document-types';
var CREATE_NEW_REDIRECTS = {
    'word.new': FileType.Word,
    'templates.word.new': FileType.Word,
    'powerpoint.new': FileType.PowerPoint,
    'templates.powerpoint.new': FileType.PowerPoint,
    'excel.new': FileType.Excel,
    'templates.excel.new': FileType.Excel,
    'templates.visio.new': FileType.Visio,
};
var lazyCreateDocument = function () {
    return import(
    /*
    webpackChunkName: "create-doc-service",
    webpackPrefetch: true,
    webpackExports: ['createItem', 'fetchCreateLinkCandidateForFileType']
    */
    '@office-start/create-document-service');
};
export function getPendingCreates() {
    var numCreatesPending = 0;
    var getOrUpdatePendingCreates = function (value) {
        if (value !== undefined) {
            if (value > 0) {
                numCreatesPending++;
            }
            else {
                numCreatesPending--;
            }
        }
        return numCreatesPending;
    };
    return getOrUpdatePendingCreates;
}
export function navigateToCreateNew(msUrlParam, templateId, prefetchedToken) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, createItem, fetchCreateLinkCandidateForFileType, createCandidates, fileType, getOrUpdatePendingCreates, candidate;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    msUrlParam = msUrlParam.toLowerCase();
                    return [4 /*yield*/, lazyCreateDocument()];
                case 1:
                    _a = _b.sent(), createItem = _a.createItem, fetchCreateLinkCandidateForFileType = _a.fetchCreateLinkCandidateForFileType;
                    return [4 /*yield*/, fetchCreateLinkCandidateForFileType()];
                case 2:
                    createCandidates = _b.sent();
                    fileType = CREATE_NEW_REDIRECTS[msUrlParam];
                    if (fileType) {
                        getOrUpdatePendingCreates = getPendingCreates();
                        candidate = createCandidates === null || createCandidates === void 0 ? void 0 : createCandidates.get(fileType);
                        if (candidate) {
                            createItem({
                                app: fileType,
                                candidate: candidate,
                                getOrUpdatePendingCreates: getOrUpdatePendingCreates,
                                linkTarget: '_self',
                                template: { AssetId: templateId },
                                prefetchedToken: prefetchedToken,
                            });
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=navigateToCreateNew.js.map